import { useEffect, useState } from 'react';
import { auth } from 'utils/firebase'; // Import your firebase auth
import Header from 'components/global/Header';
import Sidebar from 'components/global/Sidebar';
import { Container } from 'react-bootstrap';
import { Navigate, useLocation } from 'react-router-dom';
import { $app, $auth, $user } from 'signals/global.signals';

const PrivateRoute = ({ component: Component, userTypeAllowed = 'any', Layout = null }) => {
  const location = useLocation();
  const [adminStatus, setAdminStatus] = useState(null);

  // Check admin status when userTypeAllowed is 'admin'
  useEffect(() => {
    const checkAdminStatus = async () => {
      if (userTypeAllowed === 'admin' && auth.currentUser) {
        try {
          const tokenResult = await auth.currentUser.getIdTokenResult();
          setAdminStatus(tokenResult.claims.admin === true);
        } catch (error) {
          console.error('Error checking admin status:', error);
          setAdminStatus(false);
        }
      } else {
        setAdminStatus(null);
      }
    };

    if ($auth.value.isSignedIn) {
      checkAdminStatus();
    }
  }, [userTypeAllowed, $auth.value.isSignedIn]);

  if ($user.value.isLoading !== false) {
    return null;
  }
  
  // Show loading while checking admin status
  if (userTypeAllowed === 'admin' && adminStatus === null) {
    return null; // or a loading spinner
  }

  if (!$auth.value.isSignedIn) {
    return <Navigate to="/login" replace />;
  }
  
  // If user is archived, redirect to signup with helpful message
  if ($user.value.archived) {
    return <Navigate to="/signup" replace />;
  }
  
  if ($user.value.onboardingStep !== 'completed' && !location.pathname.includes('/on-boarding')) {
    return <Navigate to="/on-boarding" replace />;
  }

  // Check admin access
  if (userTypeAllowed === 'admin' && !adminStatus) {
    return <Navigate to="/" replace />;
  }

  if (userTypeAllowed !== 'any' && userTypeAllowed !== 'admin' && userTypeAllowed !== $user.value.userType) {
    return <Navigate to="/" replace />;
  }
  if (Layout) {
    return (
      <Layout>
        <Component />
      </Layout>
    );
  }

  return (
    <>
      <Header />
      <div className="main-wrapper w-100 bg-gray-800 pb-80" style={{ minHeight: 'calc(100vh - 80px)' }}>
        <Sidebar />
        <div className={`content-wrapper position-relative px-0 px-md-16 pt-40 ${$app.value.isMenuOpen ? 'expanded' : ''}`}>
          <div className="overlay position-absolute h-100 w-100" />
          <Container fluid>
            <Component />
          </Container>
        </div>
      </div>
    </>
  );
};

export default PrivateRoute;
